import {Inject, Injectable, Optional} from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';

@Injectable({providedIn: 'root'})
export class AdressService {

  private host = '';

  constructor(
    @Optional()
    @Inject(APP_BASE_HREF)
    origin: string
  ) {
    // this.host = `${origin}`;
    this.host = '';
  }

  // 商户配置
  public getMerchantConfig(appId): string {
    return appId ? `${this.host}/a/config?appId=${appId}` : `${this.host}/a/config`;
  }

  // 获取首页数据
  public getHome(appId, lang): string {
    return appId ? `${this.host}/a/home?appId=${appId}&category=1&lang=${lang}` : `${this.host}/a/home?category=1&lang=${lang}`;
  }

  // 获取模板数据
  public getTemplateById(id, appId, lang): string {
    return appId ? `${this.host}/a/template/${id}?appId=${appId}&category=1&lang=${lang}` : `${this.host}/a/template/${id}?category=1&lang=${lang}`;
  }

  // 获取详情内容
  public getContentById(id, appId, lang): string {
    return appId ? `${this.host}/a/contents/${id}?appId=${appId}&lang=${lang}` : `${this.host}/a/contents/${id}?lang=${lang}`;
  }

  // 条件查询内容列表
  public getContentList(appId): string {
    return appId ? `${this.host}/a/contents/search?appId=${appId}` : `${this.host}/a/contents/search`;
  }

  // 分类列表接口
  public getClassifyList(appId): string {
    return appId ? `${this.host}/a/classify/search?appId=${appId}` : `${this.host}/a/classify/search`;
  }

  // 获取详情内容 (受IP限制)
  public getIpContentById(id, appId, lang): string {
    return appId ? `${this.host}/a/ip/contents/${id}?appId=${appId}&lang=${lang}` : `${this.host}/a/ip/contents/${id}?lang=${lang}`;
  }

  // 查子女信息 (受IP限制)
  public getChildInformationList(appId): string {
    return appId ? `${this.host}/a/u/student/search?appId=${appId}` : `${this.host}/a/u/student/search`;
  }

  // 查收获地址 (受IP限制)
  public shippingAddressSearch(appId): string {
    return appId ? `${this.host}/a/u/address/search?appId=${appId}` : `${this.host}/a/u/address/search`;
  }

  // 貔貅币查询
  public getHoneypot(): string {
    return `${this.host}/v1/test`;
  }

  // 获取 省市区
  public getProvinceList(): string {
    return `/a/u/province/search`;
  }

  // 提交联系我们
  public addVisitLog(): string {
    return `/a/visit_log`;
  }

  // 获取溯源码校验
  public getCodeDetail(code: string): string {
    return `/a/temp_data/${code}`;
  }

  // 更改溯源码状态
  public updateCodeStatus(id: string): string {
    return `/a/temp_data/scanstatus/${id}`;
  }
}
